export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function toUpper(str) {
    return str.toUpperCase();
}

export function toLower(str) {
    return str.toLowerCase();
}

export function trim(str){
    return str.trim();
}

export function delSpaces(str){
    return str.replace(/\s+/g, '');
}

export function delHyphen(str){
    return str.replace(/-/g, "");
}

export function propsStringEnumValidator(permittedArr){
    if(!Array.isArray(permittedArr)){
        throw new Error("validator permitted values isn't arrays")
    }

    const len = permittedArr.length;
    
    for(let i = 0; i < len - 1; i++){
        if(typeof permittedArr[i] !== "string"){
            throw new Error("enum values isn't string type");
        }
        permittedArr[i] = permittedArr[i].toLowerCase();
    }

    return function(value){
        value = value.toLowerCase();
        const isValid = (permittedArr.indexOf(value) != -1) ? true : false;
        return isValid;
    }
}